import { useContext } from 'react';
import { ErrorContext, ErrorContextProps } from 'src/providers/ErrorContextProvider';

export const useErrorContext = (): ErrorContextProps => {
  return useContext(ErrorContext);
};
